"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldTextarea = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("../../../../types/react");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Wrapper_1 = require("../Wrapper");
require("./index.scss");
const className = 'form-field-textarea';
exports.FormFieldTextarea = (0, react_2.withRef)((props, ref) => {
    const { info, error, label, modificators, required, hidden, ...restProps } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { label: label, error: error, info: info, modificators: [modificators, 'free-height'], required: required, additionClassNames: (0, classFunctions_1.getClassNames)(className, modificators), slot: react_1.default.createElement("div", { className: `${className}__input` },
            react_1.default.createElement("textarea", { ...restProps, ref: ref })) }));
});
//# sourceMappingURL=index.js.map